var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarAltIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.75 19.32L14.96 19.32C15.25 19.32 15.5 19.08 15.5 18.78L15.5 15.57C15.5 15.27 15.25 15.03 14.96 15.03L11.75 15.03C11.45 15.03 11.21 15.27 11.21 15.57L11.21 18.78C11.21 19.08 11.45 19.32 11.75 19.32ZM21.39 9.14L19.78 9.14L19.78 7.53C19.78 7.24 19.54 7 19.25 7L18.17 7C17.88 7 17.64 7.24 17.64 7.53L17.64 9.14L13.35 9.14L13.35 7.53C13.35 7.24 13.11 7 12.82 7L11.75 7C11.45 7 11.21 7.24 11.21 7.53L11.21 9.14L9.6 9.14C8.71 9.14 8 9.86 8 10.75L8 22.53C8 23.42 8.71 24.14 9.6 24.14L21.39 24.14C22.28 24.14 23 23.42 23 22.53L23 10.75C23 9.86 22.28 9.14 21.39 9.14ZM21.39 22.33C21.39 22.44 21.3 22.53 21.19 22.53L9.8 22.53C9.69 22.53 9.6 22.44 9.6 22.33L9.6 12.35L21.39 12.35L21.39 22.33Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAltIcon);
export default __webpack_public_path__ + "static/media/calendarAltIcon.a64b11c2.svg";
export { ForwardRef as ReactComponent };